import { launchError, launchSuccess } from "components/notifications";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import './userSales.css'
import SearchUser from "components/SearchUser/SearchUser";
import { searchUsers } from "services/fetchUsers";
import { deleteUserSales, setUserSales } from "services/userServices";


const UserSales = ({ userData, setUserData, user, id }) => {

  const { t } = useTranslation();

  const [convertedUsers, setConvertedUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState({})

  const handleSearchReferrals = async (search) => {
    if (search.length > 0) {
      try {
        const fetchedUsers = await searchUsers(user, search, true)
        setConvertedUsers(fetchedUsers)
      } catch (e) {
        console.error(e)
      }
    } else {
      setConvertedUsers([])
    }
  }

  const addSales = async () => {
    try {
      if (selectedUser.uuid) {
        await setUserSales(user, selectedUser.uuid, id);
        const converted = [...userData.sales_converted_users];
        converted.push(selectedUser)
        setUserData({ ...userData, sales_converted_users: converted });
        setSelectedUser({});
        setConvertedUsers([])
        launchSuccess(t('notifications.users.userById.add_sales.success'))
      }
    } catch (error) {
      launchError(t('notifications.users.userById.add_sales.error'))
    }
  }

  const removeUserFromConverted = async (user_uuid) => {
    try {
      await deleteUserSales(user, user_uuid);
      const converted = [...userData.sales_converted_users];
      const index = converted.findIndex(({ uuid }) => uuid === user_uuid)
      converted.splice(index, 1);
      setUserData({ ...userData, sales_converted_users: converted });
      launchSuccess(t('notifications.users.userById.remove_sales.success'))
    } catch (error) {
      launchError(t('notifications.users.userById.remove_sales.error'))
    }
  }


  return <div className='user_sales_case'>
    <p className='user_doc_title'>Sales :</p>
    <div className='user_row_space_between_box'>

      <SearchUser
        id='search_user_input'
        selectUser={setSelectedUser}
        selectedUser={selectedUser}
        users={convertedUsers}
        handleSearch={handleSearchReferrals}
        label={'Rechercher un utilisateur converti par le sales'}
      />
      <button className='user_action_button' onClick={addSales} disabled={!selectedUser.uuid}>Ajouter</button>
    </div>
    <p className='user_doc_title'>Liste des utilisateurs converti par le sales :</p>
    <div className='user_row_space_between_box'>
      <div className='user_sales_box'>
        {userData.sales_converted_users.slice(0, Math.ceil(userData.sales_converted_users.length / 2)).map(({ uuid, firstName, lastName, email }) =>
          (<p key={uuid} className='user_sales_p user_sales_associated_users'>{firstName} {lastName} ({email})<span><button className='user_sales_delete_button' onClick={() => removeUserFromConverted(uuid)}>X</button></span></p>)
        )}
      </div>
      <div className='user_sales_box'>
        {userData.sales_converted_users.slice(Math.ceil(userData.sales_converted_users.length / 2)).map(({ uuid, firstName, lastName, email }) =>
          (<p key={uuid} className='user_sales_p user_sales_associated_users'>{firstName} {lastName} ({email})<span><button className='user_sales_delete_button' onClick={() => removeUserFromConverted(uuid)}>X</button></span></p>)
        )}
      </div>
    </div>
  </div>
}

export default UserSales